import React, { useCallback, useState, useEffect, Suspense } from "react";
import { Avatar, IconButton, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { HomeButton } from "../../../assets/icons";
import { ButtonsContainer, FixedSideBar, LogoBlock, LogoContainer, SidebarContainer } from "./styles";
import { DownloadedDocumentFile } from "../../../models/documents/document-files";
import { makeBlobUrl } from "../../../services/documents/document-files-api.service";
import { ProvidersApiService } from "../../../services/providers/providers-api.service";

export const SidebarLike = () => {
  const [logo, setLogo] = useState<string>("");
  const [loadingLogo, setLoadingLogo] = useState<boolean>(false);
  const theme = useTheme();
  const getLogoURL = useCallback(async (signal?: AbortSignal) => {
    setLoadingLogo(true);
    try {
      const { data, error }: DownloadedDocumentFile = await new ProvidersApiService().loadCurrentProviderLogoBlob(
        signal
      );

      if (!signal?.aborted && !error) {
        setLogo(makeBlobUrl(data));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingLogo(false);
    }
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    getLogoURL(abortController.signal);
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <>
      <SidebarContainer>
        <FixedSideBar>
          <ButtonsContainer>
            <Avatar variant={"rounded"}>
              <LogoBlock>
                {loadingLogo ? (
                  <Skeleton
                    width={80}
                    variant={"rectangular"}
                    height={80}
                  />
                ) : (
                  logo && (
                    <LogoContainer
                      src={logo}
                      alt=""
                      height={80}
                    />
                  )
                )}
              </LogoBlock>
            </Avatar>
            <IconButton>
              <Link
                to="/"
                style={{ color: theme.palette.text.primary }}
              >
                <HomeButton />
              </Link>
            </IconButton>
          </ButtonsContainer>
        </FixedSideBar>
      </SidebarContainer>
    </>
  );
};
